import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import './i18n';
import { supabase } from './integrations/supabase/client';

// Initialize Supabase auth settings with better error handling
const initializeSupabaseAuth = async () => {
  try {
      // Try to get the current session
      const { data: { session }, error } = await supabase.auth.getSession();
      
      if (session) {
        console.log('Supabase auth initialized successfully from current session');
      } else {
        console.log('No active session found');
      }
    
      
  } catch (error) {
    console.error('Error initializing Supabase auth:', error);
  }
};

// Initialize auth before rendering the app
initializeSupabaseAuth().then(() => {
  const root = createRoot(document.getElementById('root')!);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
});
